import { plannedDate, plannedDateTimestamp } from '../utils/format'

export function currentMonth() { return plannedDate(Date.now()).slice(0, 7) }
export function shiftMonth(value: string, shift: number) { const [year, month] = value.split('-').map(Number); const next = new Date(year, month - 1 + shift, 1); return `${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, '0')}` }
export function dayKey(value: string) { return plannedDate(value) }
export function monthBounds(value: string) {
  const [year, month] = value.split('-').map(Number)
  return { from: plannedDateTimestamp(`${value}-01`), to: plannedDateTimestamp(`${new Date(Date.UTC(year, month, 1)).toISOString().slice(0, 10)}`) }
}
export function monthDays(value: string): Array<string | null> {
  const [year, month] = value.split('-').map(Number)
  const padding = (new Date(year, month - 1, 1).getDay() + 6) % 7
  const total = new Date(year, month, 0).getDate()
  return [...Array<null>(padding).fill(null), ...Array.from({ length: total }, (_, index) => `${value}-${String(index + 1).padStart(2, '0')}`)]
}
export function orderCountLabel(count: number) {
  const ending = count % 100 >= 11 && count % 100 <= 14 ? 'заданий' : count % 10 === 1 ? 'задание' : count % 10 >= 2 && count % 10 <= 4 ? 'задания' : 'заданий'
  return `${count} ${ending}`
}
